<template>
  <div :title="`${action_name} ${module_name}`" button-accept="false" button-cancel="false" :active.sync="isActive">
    <div class="mb-4 flex items-center">
      <vs-button @click="isActive = false" color="dark" type="filled" icon-pack="feather" icon="icon-arrow-left"> Back </vs-button>
    </div>
    <div class="vx-col w-full md:w-1/4 px-4">
      <form method="POST" @submit.prevent="save_changes">
        <!-- Name -->
        <div class="vx-row mb-3">
          <vs-input
            icon-pack="feather"
            class="w-full"
            v-validate="'required|exclude_special_char'"
            v-model="form.service_name"
            label="Service Name *"
            placeholder="Prayer"
            name="Service Name"
            id="Service Name"
            :disabled="!isEditable"
          />
          <span class="text-danger text-sm" v-show="errors.has('Service Name')">{{ errors.first('Service Name') }}</span>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row">
          <div class="flex flex-wrap items-center justify-start">
            <vs-button class="mr-2 vs-con-loading__container" id="create-service" v-if="isEditable" @click="save_changes">Save Changes</vs-button>
            <vs-button @click="navigateList" color="danger" class="text-white-500">Cancel</vs-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  /** Page Name */
  name: 'AddUpdate',

  props: {
    selectedRecordId: String,
    module_name: String,
    action_name: String,
    showModal: Boolean
  },

  /** data */
  data() {
    return {
      form: {
        service_name: null,
        organization: this.$route.params.id
      }
    }
  },

  /** computed */
  computed: {
    ...mapState('availableService', ['createLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    isEditable() {
      return this.checkPermissionSlug('available_service_edit')
    },
    validateForm() {
      return !this.errors.any()
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  /** created */
  async created() {
    if (this.selectedRecordId) {
      await this.$store.dispatch('availableService/show', this.selectedRecordId).then(async (res) => {
        const data = res.data.data
        this.form.service_name = data.service_name
      })
    }
  },

  /** methods */
  methods: {
    ...mapActions('availableService', {
      create: 'create',
      update: 'update'
    }),
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.isActive = false
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        if (this.selectedRecordId) {
          response = await this.update({
            id: this.selectedRecordId,
            data: this.form
          })
        } else {
          response = await this.create(this.form)
        }
        this.isActive = false

        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-service',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-service > .con-vs-loading')
      }
    }
  }
}
</script>

<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}

.color {
  background-image: none !important;
}
</style>
